/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Use_2_ValueInputs */

const en_svc_integration_use_2_value = /** @type {(inputs: Svc_Integration_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders arriving by email turned into structured records in your system.`)
};

const lv_svc_integration_use_2_value = /** @type {(inputs: Svc_Integration_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pa e-pastu saņemti pasūtījumi kļūst par strukturētiem ierakstiem Jūsu sistēmā.`)
};

/**
* | output |
* | --- |
* | "Orders arriving by email turned into structured records in your system." |
*
* @param {Svc_Integration_Use_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_use_2_value = /** @type {((inputs?: Svc_Integration_Use_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Use_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_use_2_value(inputs)
	return en_svc_integration_use_2_value(inputs)
});